import { fetchAtom } from "data/api/useFetch"
import { atom, useAtomValue } from "jotai"

const ENDPOINT = "/v3/internal/projects" as const

const projectsWithPlaceholdersMetaAtom = atom(async (get) => {
  const { ok: payload } = await get(
    fetchAtom((ENDPOINT + "?include=placeholder") as typeof ENDPOINT)
  )

  return payload?.data ?? []
})

export function useProjectsWithPlaceholdersMeta() {
  return useAtomValue(projectsWithPlaceholdersMetaAtom)
}
